function normalizeUid(value) {
  if (value == null) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "object") {
    return String(value.uid || value.id || "").trim();
  }
  return String(value).trim();
}

/**
 * Resolve o UID do embarcador pagador a partir de um registro de frete.
 * Prioridade: clientPayment.uid > client.uid > pagador legado > shipper.uid
 */
export function resolvePayingShipperUid(source, fallbackUid = "") {
  if (!source || typeof source !== "object") {
    return normalizeUid(fallbackUid);
  }

  const shipperField = source.shipper;
  const shipperUid = Array.isArray(shipperField?.uid)
    ? shipperField.uid[0]
    : shipperField?.uid;

  const uid =
    source?.clientPayment?.uid ||
    source?.client?.uid ||
    source?.pagador ||
    source?.freight?.pagador ||
    source?.idShipper ||
    shipperUid ||
    fallbackUid ||
    "";

  return normalizeUid(uid);
}

/**
 * Resolve o UID do pagador selecionado no formulário de frete.
 */
export function resolvePayingShipperFromForm({
  uidShipperPayment,
  listECShipper,
} = {}) {
  if (listECShipper && typeof listECShipper === "object" && listECShipper.id) {
    return String(listECShipper.id).trim();
  }

  return normalizeUid(uidShipperPayment);
}

/**
 * Usado na listagem — prioriza pagador persistido no frete.
 */
export function resolveEmbarcadorUid(record, user) {
  const fromRecord = resolvePayingShipperUid(record);
  if (fromRecord) return fromRecord;
  return normalizeUid(user?.uidShipper);
}
